export const PAGE_ACCESS_HIDDEN = 0;
export const PAGE_ACCESS_FULL = 15;

export function setSidebarPin({
  links = [],
  sidebarLinks = [],
  linkId,
  pinned,
}) {
  const nextSidebar = (sidebarLinks ?? []).filter(
    (entry) => entry?.link !== linkId
  );

  if (!pinned) {
    const nextLinks = (links ?? []).map((entry) =>
      entry?.link === linkId
        ? { ...entry, accessRight: PAGE_ACCESS_HIDDEN }
        : entry
    );
    return { links: nextLinks, sidebarLinks: nextSidebar };
  }

  nextSidebar.push({ link: linkId });
  const index = (links ?? []).findIndex((entry) => entry?.link === linkId);
  const current = index >= 0 ? Number(links[index].accessRight ?? 0) : 0;
  if (current > PAGE_ACCESS_HIDDEN) {
    return { links, sidebarLinks: nextSidebar };
  }

  const nextLinks = [...(links ?? [])];
  if (index >= 0) {
    nextLinks[index] = { ...nextLinks[index], accessRight: PAGE_ACCESS_FULL };
  } else {
    nextLinks.push({ link: linkId, accessRight: PAGE_ACCESS_FULL });
  }
  return { links: nextLinks, sidebarLinks: nextSidebar };
}

export function isSidebarPinned(sidebarLinks, linkId) {
  return (sidebarLinks ?? []).some((entry) => entry?.link === linkId);
}

export function setAllSettingPagesActive({
  links = [],
  sidebarLinks = [],
  linkIds = [],
}) {
  const idSet = new Set(linkIds);
  const kept = (sidebarLinks ?? []).filter((entry) => !idSet.has(entry?.link));
  let nextLinks = [...(links ?? [])];
  const added = linkIds.map((linkId) => ({ link: linkId }));

  for (const linkId of linkIds) {
    const result = setSidebarPin({
      links: nextLinks,
      sidebarLinks: [...kept, ...added],
      linkId,
      pinned: true,
    });
    nextLinks = result.links;
  }

  return { links: nextLinks, sidebarLinks: [...kept, ...added] };
}

export function clearSettingPagePins({
  links = [],
  sidebarLinks = [],
  linkIds = [],
}) {
  const idSet = new Set(linkIds);
  return {
    links: (links ?? []).map((entry) =>
      idSet.has(entry?.link)
        ? { ...entry, accessRight: PAGE_ACCESS_HIDDEN }
        : entry
    ),
    sidebarLinks: (sidebarLinks ?? []).filter((entry) => !idSet.has(entry?.link)),
  };
}

export function areAllSettingPagesActive(sidebarLinks, linkIds) {
  if (!linkIds?.length) return true;
  return linkIds.every((linkId) => isSidebarPinned(sidebarLinks, linkId));
}
